(function (Drupal, once, $) {
  'use strict';

  Drupal.behaviors.splideInit = {
    attach(context) {
      once('splideInit', '.js-splide', context).forEach((el) => {

        // Lê opções do data-splide (JSON) se houver
        let opts = {};
        const raw = $(el).data('splide');
        if (raw) {
          if (typeof raw === 'string') {
            try { opts = JSON.parse(raw); } catch (e) { console.warn('Erro ao parsear data-splide:', raw); }
          } else if (typeof raw === 'object') {
            opts = raw;
          }
        }

        // Defaults seguros
        opts = Object.assign({
          type: 'loop',
          perPage: 1,
          perMove: 1,
          arrows: true,
          gap: '20px',
          pagination: true,
          autoplay: false,
          interval: 4000,
          autoHeight: false,
          breakpoints: { 768: { perPage: 1 } },
        }, opts);

        // Deep copy simples
        let ACTIVE_OPTS = $.extend(true, {}, opts);

        // Ajuste específico
        if ($(el).find('.view-area_admin_1').length) {
          opts.autoWidth = true;
          opts.gap = '20px';
          opts.drag = 'free';
          opts.padding = { left: '0', right: '0' };
          opts.breakpoints = {
            768: {
              grid: { rows: 2, cols: 2, gap: { row: '15px', col: '15px' } },
              perPage: 1,
              perMove: 1,
              pagination: true,
              padding: 0,
              drag: true,
              autoWidth: false, 
            }
          };

          // Deep copy somente para o caso de slide mobileOnly para a view de area admin
          ACTIVE_OPTS = {
            ...opts,
            type: 'slide',
            perPage: 1,
            perMove: 1,
            pagination: true,
            padding: 0,
            drag: true,
          };
        }

        if($(el).find('.view-depoimentos_block').length) {
          opts.breakpoints = {
            768: { 
              perPage: 1,
              perMove: 1,
              padding: { left: '0', right: '45px' }
            }
          }
        } 

        if($(el).find('.view-subcategorias').length){
          opts.breakpoints = {
          768: {
              grid: { rows: 2, cols: 2, gap: { row: '8px', col: '8px' } },
              perPage: 1,
              perMove: 1,
            }
          }
        }

        // Pacote de "opções desativadas" (modo estático)
        const DISABLED_OPTS = {
          type: 'slide',
          drag: false,
          arrows: false,
          pagination: false,
          keyboard: false,
          wheel: false,
          autoplay: false,
          pauseOnHover: false,
          pauseOnFocus: false,
          autoWidth: true,
          autoHeight: false,
          perPage: 1,
          perMove: 0,
          direction: 'ltr',
          focus: 0,
          gap: '0px',
          padding: 0,
        };

        const WINDOW_SIZE = 1024;

        const splide = new Splide(el, opts).mount(window.splide.Extensions);

        let isDisabled = false;

        function applyDisabled(disable) {
          if (disable) {
            splide.options = $.extend(true, {}, splide.options, DISABLED_OPTS);
          } else {
            splide.options = $.extend(true, {}, ACTIVE_OPTS);
          }
          splide.refresh();
        }

        function checkSlider() {
          const desktop = $(window).width() >= WINDOW_SIZE;
          const shouldDisable = !!opts.disableDesktop && desktop;

          if (shouldDisable && !isDisabled) {
            applyDisabled(true);
            isDisabled = true;
          } else if (!shouldDisable && isDisabled) {
            applyDisabled(false);
            isDisabled = false;
          }
        }

        // Estado inicial
        checkSlider();

        // Resize com debounce
        let t;
        $(window).on('resize.splideToggle', function () {
          clearTimeout(t);
          t = setTimeout(checkSlider, 200);
        });

      });
    }
  };
})(Drupal, once, jQuery);
